var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2495 5.36377C13.0038 5.4364 13.594 6.07103 13.5942 6.84424V12.105C13.5942 12.9272 12.9272 13.5942 12.105 13.5942H6.84619C6.07298 13.5942 5.43864 13.0046 5.36572 12.2505H6.59717C6.64734 12.3363 6.73977 12.394 6.84619 12.394H12.105C12.2645 12.394 12.394 12.2645 12.394 12.105V6.84424C12.3938 6.73775 12.3355 6.64524 12.2495 6.59521V5.36377Z",
    fill: "#002A69"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#002A69",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H9M7 5V9",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.a5f57a6480bde7bfaae12581613d527c.svg";
export { ForwardRef as ReactComponent };